import { useState } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { closeModal, openModal } from '@ds/components/ModalBase'

import translations from '../components/MobileFilters.translations'
import { FULL_SCREEN_MODAL_NAME } from '../constants'
import type { Facet, UiPriceFacet } from '../types'

export function useFullscreenFilters() {
  const i18n = useI18n()
  const displayed = useState('plp-fullscreen-filters-display', () => false)
  const disableGoBack = useState(
    'plp-fullscreen-filters-enable-go-back',
    () => false,
  )
  const type = useState<'filter' | 'sort'>(
    'plp-fullscreen-filters-type',
    () => 'filter',
  )
  const selectedFacet = useState<Facet | UiPriceFacet | undefined>(
    'plp-fullscreen-filters-selected-facet',
    () => undefined,
  )

  const title = computed(() => {
    if (type.value === 'sort') return i18n(translations.titleSort)
    if (selectedFacet.value) return selectedFacet.value.title

    return i18n(translations.titleFilter)
  })

  function filter(
    event: PointerEvent | KeyboardEvent,
    facet?: Facet | UiPriceFacet | undefined,
  ) {
    type.value = 'filter'
    if (facet) {
      selectedFacet.value = facet
      disableGoBack.value = true
    }
    openModal(FULL_SCREEN_MODAL_NAME, event)
  }
  function sort(event: PointerEvent | KeyboardEvent) {
    type.value = 'sort'
    openModal(FULL_SCREEN_MODAL_NAME, event)
  }
  function close() {
    disableGoBack.value = false
    closeModal(FULL_SCREEN_MODAL_NAME)
  }
  function selectFacet(facet: Facet | UiPriceFacet) {
    selectedFacet.value = facet
  }
  function clearFacet() {
    selectedFacet.value = undefined
  }

  return {
    displayed,
    type,
    filter,
    sort,
    close,
    selectedFacet,
    selectFacet,
    clearFacet,
    title,
    disableGoBack,
  }
}
